import { FeeTypeType } from '../../types/index';
import { atom } from "recoil";

export const addStateFeeType = atom({
  key: "addStateFeeType",
  default: false,
});
export const editStateFeeType = atom({
  key: "editStateFeeType",
  default: false,
});
export const disableButtonStateFeeType = atom({
  key: "disableButtonStateFeeType",
  default: false,
});

export const selectedRowsStateFeeType = atom<Pick<FeeTypeType, 'feeTypeId'>[] | []>({
  key: "selectedRowsStateFeeType",
  default: [],
});

export const setFilterTextFeeType = atom({
  key: "setFilterTextFeeType",
  default: "",
});

export const rowEditIdStateFeeType = atom<FeeTypeType | null>({
  key: "rowEditIdStateFeeType",
  default: {
    feeTypeId: 0,
    feeTypeName: "",
    createdBy: "",
    createdDate: new Date,
    modifiedBy: "",
    modifiedDate: new Date,
    isActive: true
  }
});

export const feeTypeSaving = atom({
  key: "feeTypeSaving",
  default: false,
});